import * as React from 'react';
export const IcESim = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16 2h-5a2.993 2.993 0 00-2.38 1.13l-3 3.7c-.41.54-.63 1.19-.62 1.87V19c0 .8.32 1.56.88 2.12S7.21 22 8 22h8c.8 0 1.56-.32 2.12-.88S19 19.79 19 19V5c0-.8-.32-1.56-.88-2.12S16.79 2 16 2zM7 12h3v3H7v-3zm5 8H8c-.27 0-.52-.11-.71-.29A.99.99 0 017 19v-2h5v3zm5-1c0 .27-.11.52-.29.71A.99.99 0 0116 20h-2v-3h3v2zm0-4h-5v-3h5v3z'
      fill='currentColor'
    />
    <path
      d='M16.11 5.74c.01.13-.04.25-.12.35-.05.05-.1.09-.17.12-.06.02-.12.04-.2.04a.55.55 0 01-.32-.12 4.402 4.402 0 00-3-1.17c-1.11 0-2.19.41-3.01 1.17-.09.08-.21.12-.33.12h-.02a.543.543 0 01-.34-.16.499.499 0 01.04-.69c1-.91 2.3-1.41 3.66-1.41 1.36 0 2.65.5 3.65 1.41.1.09.15.21.16.34z'
      fill='#fff'
    />
    <path
      d='M14.86 6.49c-.72-.61-1.63-.95-2.56-.95-.93 0-1.85.33-2.56.95-.1.09-.16.2-.17.33-.01.13.03.26.11.36.09.09.21.15.33.16h.04c.12 0 .23-.04.32-.11.53-.46 1.22-.71 1.93-.71s1.39.25 1.93.71c.08.07.2.11.31.11h.04c.12-.01.25-.07.33-.16.08-.1.12-.23.11-.36a.518.518 0 00-.16-.33zm-4.81.76h-.03H10.05zm4.49 0h-.02H14.54z'
      fill='#fff'
    />
    <path
      d='M13.92 7.9c.01.06.01.12-.01.19a.38.38 0 01-.08.17.39.39 0 01-.17.14c-.07.03-.14.05-.22.05-.1 0-.2-.03-.29-.1a1.443 1.443 0 00-1.71 0c-.09.07-.19.1-.29.1h-.07a.507.507 0 01-.32-.19.47.47 0 01-.09-.36c.02-.13.08-.25.19-.32a2.397 2.397 0 012.88 0c.05.04.09.08.12.14.03.05.06.11.06.18zM12.97 9.32c0 .13-.04.26-.11.37-.08.12-.18.2-.31.25-.08.04-.16.05-.25.05-.05 0-.09 0-.14-.01a.701.701 0 01-.34-.18c-.1-.1-.16-.22-.19-.35-.02-.13 0-.27.04-.39.05-.13.14-.23.25-.3.11-.08.24-.12.38-.12.18 0 .35.07.47.2.13.12.2.3.2.48z'
      fill='#fff'
    />
  </svg>
);
